export const getAffiliatePromoInfo = (affiliate, submittedPromoCodes = []) => {
  if (!affiliate) return null;

  const affiliatePromo = submittedPromoCodes.find(promo => promo.is_affiliate);

  if (!affiliatePromo) return null;

  return {
    name: affiliate.name,
    discount_amount: affiliatePromo.discount_amount,
    discount_type: affiliatePromo.discount_type,
    max_order_total: affiliatePromo.max_order_total
  };
};
